import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// lib stylesheet
import "./lib/animate/animate.min.css"
import "./lib/owlcarousel/assets/owl.carousel.min.css"
import "./lib/lightbox/css/lightbox.min.css"
import "./css/bootstrap.min.css"
import "./css/style.css"
import ErrorBoundary from './pages/error-pages/ErrorBoundary';



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
     <ErrorBoundary>
    
    <App />
     </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
